export const WHATSAPP_CHATBOT_URL = "/byb-chatbot/index.html";
